export const MOLECULE_BUILT_IN_FIELDS = {
  NAME: '__molecule_name__',
  STRUCTURE_SMILES: '__molecule_structure_smiles__',
  STRUCTURE_MOLFILE: '__molecule_structure_molfile__',
  ALIAS: '__molecule_alias__',
} as const;
